import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.scss';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import About from './pages/About/About';
import AiNativeWorkflow from './pages/AiNativeWorkflow/AiNativeWorkflow';
import AinurPOS from './pages/AinurPOS/AinurPOS';
import HseApp from './pages/HseApp/HseApp';
import Main from './pages/Main/Main';
import Playground from './pages/Playground/Playground';
import Safe from './pages/Safe/Safe';
import Streamy from './pages/Streamy/Streamy';

function App() {
  // React.useEffect(() => {
  //   const handleResize = () => {
  //     const rootElement = document.documentElement;
  //     const bodyElement = document.body;

  //     if (bodyElement.scrollHeight <= window.innerHeight) {
  //       rootElement.style.overflowY = 'hidden';
  //     } else {
  //       rootElement.style.overflowY = 'auto';
  //     }
  //   };

  //   // Initial check
  //   handleResize();
  //   // Add event listener for window resize
  //   window.addEventListener('resize', handleResize);
  //   // Cleanup function to remove event listener
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);

  return (
      <div className="App">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/ai-native-workflow" element={<AiNativeWorkflow />} />
          <Route path="/ainurpos" element={<AinurPOS />} />
          <Route path="/streamy" element={<Streamy />} />
          <Route path="/hse-app" element={<HseApp />} />
          <Route path="/playground" element={<Playground />} />
          <Route path="/impersonation" element={<Safe />} />
        </Routes>
        <Footer />
      </div>
  );
}

export default App;
